import { LinkBreak, ShieldCheck, Warning } from '@phosphor-icons/react';
import { Button, Link, Stack } from '@reelplicate/ui';
import { Link as RouterLink } from 'react-router';

import { AuthBody, AuthCard, AuthFooter, AuthHeader } from './auth-card';

/** Gmail / Outlook shortcuts (Figma "Mail shortcuts"). */
export function MailShortcuts() {
  return (
    <Stack gap={3} className="tablet:flex-row">
      <Button asChild variant="outline" size="lg" className="flex-1">
        <a href="https://mail.google.com" target="_blank" rel="noreferrer">
          Open Gmail
        </a>
      </Button>
      <Button asChild variant="outline" size="lg" className="flex-1">
        <a href="https://outlook.live.com" target="_blank" rel="noreferrer">
          Open Outlook
        </a>
      </Button>
    </Stack>
  );
}

export function BackToSignInButton({ variant }: { variant: 'primary' | 'ghost' }) {
  return (
    <Button asChild variant={variant} size="lg" className="w-full">
      <RouterLink to="/sign-in">Back to sign in</RouterLink>
    </Button>
  );
}

export function BackToSignInFooter() {
  return (
    <AuthFooter>
      <Link asChild>
        <RouterLink to="/sign-in">Back to sign in</RouterLink>
      </Link>
    </AuthFooter>
  );
}

/** Figma "Auth B — Sign in — provider error" (214:1323). */
export function ProviderErrorPage() {
  return (
    <AuthCard>
      <AuthHeader
        icon={{ icon: Warning, tone: 'danger' }}
        title="Could not sign you in"
        subtitle="The provider didn’t complete the sign-in. You can try again, or use your email and password."
      />
      <AuthBody>
        <BackToSignInButton variant="primary" />
      </AuthBody>
    </AuthCard>
  );
}

/**
 * Figma "Auth B — Reset password — link expired" (214:23295). Clerk resets
 * with an emailed code rather than a link, so the copy says code.
 */
export function ResetCodeExpiredPage() {
  return (
    <AuthCard>
      <AuthHeader
        icon={{ icon: LinkBreak, tone: 'warning' }}
        title="That code has expired"
        subtitle="Reset codes work once and only for a limited time. Request a new one to continue."
      />
      <AuthBody>
        <Button asChild size="lg" className="w-full">
          <RouterLink to="/forgot-password">Request a new code</RouterLink>
        </Button>
      </AuthBody>
      <BackToSignInFooter />
    </AuthCard>
  );
}

/** Figma "Auth B — Set up two-factor — done" (214:23399). */
export function TwoFactorDonePage() {
  return (
    <AuthCard>
      <AuthHeader
        icon={{ icon: ShieldCheck, tone: 'success' }}
        title="Two-factor is on"
        subtitle="You’ll be asked for a code from your authenticator app each time you sign in."
      />
      <AuthBody>
        <Button asChild size="lg" className="w-full">
          <RouterLink to="/">Continue to Reelplicate</RouterLink>
        </Button>
      </AuthBody>
    </AuthCard>
  );
}
